import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import logo from "../assets/images/logo.png";
import { getProfileImage } from "../core/common/api";
import AppImage from "./AppImage";
import Swal from "sweetalert2";

type HeaderProps = {
  onMenuClick: () => void;
};

const Header = ({ onMenuClick }: HeaderProps) => {
  const [profileData, setProfileData] = useState<any>(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const { logout } = useAuth();
  const profileImage = getProfileImage(profileData);

  useEffect(() => {
    const storedProfile = localStorage.getItem("adminProfile");
    setProfileData(storedProfile ? JSON.parse(storedProfile) : null);
  }, []);

  const handleLogout = async () => {
    const confirmation = await Swal.fire({
      title: "Log out?",
      text: "You will need to sign in again to access the admin panel.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Log out",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#9b6c2b",
    });

    if (!confirmation.isConfirmed) return;

    setShowProfileMenu(false);
    await logout();
    navigate("/");
  };

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const query = search.trim().toLowerCase();
    if (!query) return;

    if (query.includes("order") || query.startsWith("#")) {
      navigate("/orders");
    } else if (query.includes("customer") || query.includes("user")) {
      navigate("/users");
    } else if (query.includes("coupon") || query.includes("discount")) {
      navigate("/coupons");
    } else {
      navigate("/products");
    }
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <button
          type="button"
          onClick={onMenuClick}
          className="menu-button"
          aria-label="Toggle sidebar"
        >
          ☰
        </button>
        <span className="mobile-header-logo">
          <img src={logo} alt="saree house" />
        </span>

        <div className="topbar-welcome">
          <span className="topbar-greeting">Good morning,</span>
          <span className="topbar-name">{profileData?.name}</span>
        </div>
      </div>

      <form className="global-search" onSubmit={handleSearch}>
        <span>🔎</span>
        <input
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search for orders, products, user..."
        />
        <kbd>⌘K</kbd>
      </form>

      <div className="header-actions">
        <div className="profile-menu-wrap">
          <button
            type="button"
            onClick={() => setShowProfileMenu((current) => !current)}
            className="profile-chip"
            aria-expanded={showProfileMenu}
            aria-haspopup="menu"
          >
            <AppImage
              src={profileImage}
              alt={profileData?.name || "Admin"}
              crossOrigin="anonymous"
            />
            <div>
              <strong>{profileData?.name || "Admin"}</strong>
              <small>{profileData?.role || "Admin"}</small>
            </div>
            <i>⌄</i>
          </button>

          {showProfileMenu && (
            <div className="profile-dropdown" role="menu">
              <button
                type="button"
                onClick={() => {
                  setShowProfileMenu(false);
                  navigate("/profile");
                }}
                role="menuitem"
              >
                <span>👤</span>
                Profile
              </button>
              <button type="button" onClick={handleLogout} role="menuitem">
                <span>🚪</span>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
